export const SET_CURRENT_PROFILE = "SET_CURRENT_PROFILE";
export const SET_FORGOT_PASSWORD_CONFIRMATION_STATUS = "SET_FORGOT_PASSWORD_CONFIRMATION_STATUS";